import { useEffect } from "react";
import React from 'react';
import Aanmelden from "../../Components/Aanmelden/Aanmelden";
import "./Login.scss"
import 'react-toastify/dist/ReactToastify.css';
export default function Login(){
  useEffect(()=>{
    document.title = "Login"
  },[])
  return(
    <div className="loginContainer">
      <Aanmelden/>
    </div>
  );
}